(async () => {
    const videoPlayers = document.querySelectorAll('[data-video-player]');

    if (videoPlayers.length) {
        const Plyr = await import('plyr');
        await import('/components/video-player/video-player.scss');

        videoPlayers.forEach((videoPlayer) => {
            new Plyr(videoPlayer, {
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'],
            });
        });
    }
})();
